<template>
  <div>
    <h1 class="page-title">{{ $t("OfferSendToStaff.title") }}</h1>
    <div class="card card-transparent">
      <div class="card-block">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <form @submit.prevent class="p-t-15 form-horizontal" role="form" novalidate="novalidate">
              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t("OfferSendToStaff.form.replaced_occupation") }}
                </label>
                <div class="col-md-8">
                  <input name="replaced_occupation"
                            v-model="offer.replaced_occupation.name"
                            id="replaced_occupation"
                            class="form-control"
                            rows="1"
                            disabled="true"></input>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t("OfferSendToStaff.form.job_presentation") }}
                </label>
                <div class="col-md-8">
                  <textarea name="job_presentation"
                            v-model="form_fields.job_presentation"
                            v-validate="'max:4000'"
                            id="job_presentation"
                            class="form-control"
                            rows="3"></textarea>
                </div>
                <transition name="slide-fade">
                  <label v-show="errors.has('job_presentation')" id="job_presentation-error" class="error" for="job_presentation">{{
                    errors.first('job_presentation') }}</label>
                </transition>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t("OfferSendToStaff.form.searched_profile") }}
                </label>
                <div class="col-md-8">
                  <textarea name="searched_profile"
                            v-model="form_fields.searched_profile"
                            v-validate="'max:4000'"
                            id="searched_profile"
                            class="form-control"
                            rows="3"></textarea>
                </div>
                <transition name="slide-fade">
                  <label v-show="errors.has('searched_profile')" id="searched_profile-error" class="error" for="searched_profile">{{
                    errors.first('searched_profile') }}</label>
                </transition>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">{{ $t("OfferSendToStaff.form.required_experience") }}</label>
                <div class="col-md-8">
                  <div class="radio radio-success">
                    <input type="radio"
                           id="unexperienced"
                           :value="'unexperienced'"
                           v-model="form_fields.required_experience"
                           aria-invalid="false">
                    <label for="unexperienced">{{ $t('OfferSendToStaff.unexperienced') }}</label>
                    <br/>
                    <input type="radio"
                           id="junior"
                           :value="'junior'"
                           v-model="form_fields.required_experience"
                           aria-invalid="false">
                    <label for="junior">{{ $t('OfferSendToStaff.junior') }}</label>
                    <br/>
                    <input type="radio"
                           id="experienced"
                           :value="'experienced'"
                           v-model="form_fields.required_experience"
                           aria-invalid="false">
                    <label for="experienced">{{ $t('OfferSendToStaff.experienced') }}</label>
                    <br/>
                    <input type="radio"
                           id="senior"
                           :value="'senior'"
                           v-model="form_fields.required_experience"
                           aria-invalid="false">
                    <label for="senior">{{ $t('OfferSendToStaff.senior') }}</label>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t("OfferSendToStaff.form.qualification") }}
                </label>
                <div class="col-md-8">
                  <input name="qualification"
                            v-model="form_fields.qualification"
                            id="qualification"
                            class="form-control"
                            rows="1"></input>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t("OfferSendToStaff.form.location") }}
                </label>
                <div class="col-md-8">
                  <input name="location"
                            v-model="form_fields.location"
                            id="location"
                            class="form-control"
                            rows="1"></input>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">{{ $t("OfferSendToStaff.form.work_time") }}</label>
                <div class="col-md-8">
                  <div class="radio radio-success">
                    <input type="radio"
                           id="full_time"
                           :value="'full_time'"
                           v-model="form_fields.work_time"
                           aria-invalid="false">
                    <label for="full_time">{{ $t('OfferSendToStaff.full_time') }}</label>

                    <input type="radio"
                           id="part_time"
                           :value="'part_time'"
                           v-model="form_fields.work_time"
                           aria-invalid="false">
                    <label for="part_time">{{ $t('OfferSendToStaff.part_time') }}</label>
                  </div>
                </div>
              </div>

              <div class="form-group row required form-multiselect">
                <label for="published_by_id_in" class="col-md-4 control-label">
                  {{ $t("OfferSendToStaff.form.application_recipient") }}
                </label>
                <div class="col-md-8">
                  <multiselect v-model="application_recipient"
                               id="published_by_id_in"
                               label="email"
                               track-by="id"
                               :placeholder="$t('multiselect.placeholder')"
                               :showLabels="false"
                               :multiple="false"
                               :options="coworkers">
                    <span slot="noResult">{{ $t('OfferForm.no_coworkers') }}</span>
                  </multiselect>
                </div>
              </div>

              <div class="pull-right row">
                <router-link :to="backPage" class="btn btn-default btn-cons m-t-10">{{ $t("buttons.cancel") }}</router-link>
                <button type="button" @click="publish" class="btn btn-primary btn-cons m-t-10 btn-publish" :disabled="isDisabled">
                  {{ $t("OfferSendToStaff.form.publish") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'OfferSendToStaff',
    data: function() {
      return {
        form_fields: {
          job_presentation: '',
          searched_profile: '',
          required_experience: '',
          qualification: '',
          location: '',
          work_time: '',
          application_recipient_id: null
        },
        application_recipient: null
      }
    },
    computed: {
      ...mapGetters({
        offer: 'offers/offer',
        coworkers: 'users/coworkers'
      }),
      offerId(){
        return this.$route.params.id;
      },
      backPage(){
        return { name: 'AdminOffer', params: { id: this.offerId } };
      },
      isDisabled(){
        let count = 0;
        for (var key in this.form_fields) {
          if (this.form_fields[key] == '') count += 1;
        }
        return count > 0;
      }
    },
    methods: {
      ...mapActions({
        getOffer: 'offers/getOffer',
        sendOfferToStaff: 'offers/sendOfferToStaff',
        getCoworkers: 'users/getCoworkers'
      }),
      publish(){
        this.$validator.validateAll().then((result) => {
          if (result){
            this.form_fields['id'] = this.offerId;
            this.form_fields['replaced_occupation'] = this.offer.replaced_occupation.name;
            this.form_fields['entity_name'] = this.offer.entity.name;
            this.form_fields['required_experience'] = this.$i18n.t(`OfferSendToStaff.${this.form_fields['required_experience']}`);
            this.form_fields['work_time'] = this.$i18n.t(`OfferSendToStaff.${this.form_fields['work_time']}`);
            this.form_fields['application_recipient_id'] = this.application_recipient.id;
            this.sendOfferToStaff(this.form_fields);
            this.$router.push({ name: "Offers"});
          }
        })
      }
    },
    mounted: function() {
      this.getOffer(this.offerId);
      this.getCoworkers();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/offers/OfferSendToStaff.vue